import assign from 'object-assign';
import FluxEventEmitter from '../FluxEventEmitter';
import { doVxqlRequest } from './VxqlStore/common.js';

const ChangeEvents = {
	liveReaction: 'liveReaction',
};

const LiveReactionsStore = assign({}, FluxEventEmitter.prototype, {
	/**
	 *
	 * @param callback
	 * @param {string} referenceType
	 * @param {number} referenceId
	 * @param {number} imageId
	 * @param {string|null} message
	 * @param {object|null} data
	 */
	addReaction: function (callback, referenceType, referenceId, imageId, message, data) {
		if (data) {
			data = JSON.stringify(data);
		}

		const query = `
		mutation($referenceType: String!, $referenceId: Int!, $imageId: Int!, $message: String, $data: String) {
			guest {
				liveReactions {
					addReaction(referenceType: $referenceType, referenceId: $referenceId, imageId: $imageId, message: $message, data: $data)
				}
			}
		}`;

		doVxqlRequest(query, { referenceType, referenceId, imageId, message, data }).then(callback);
	},

	handleLiveReaction: function (liveReaction) {
		this.emitLiveReactionChange(liveReaction);
		liveReaction.id = liveReaction.id + 1;
	},

	addLiveReactionListener: function (callback) {
		this.addListener(ChangeEvents.liveReaction, callback);
	},

	removeLiveReactionListener: function (callback) {
		this.removeListener(ChangeEvents.liveReaction, callback);
	},

	emitLiveReactionChange: function (liveReaction) {
		this.emit(ChangeEvents.liveReaction, liveReaction);
	},
});

export default LiveReactionsStore;
